import { observer } from "mobx-react-lite"
import React, { useCallback, useState } from "react"
import LoadingSpinner from "../../../components/loading-spinner/LoadingSpinner"
import { useTheme } from "../../../services/theme-service/ThemeService";
import { Video } from "../../../services/inspection/Video";
import { translationService } from "../../../services/translation/TranslationService";
import { Warning } from "../../../components/svg/svgImageList";
import Svg from "../../../components/svg/Svg";
import { InspectionFilesStorageModel } from "../../../services/inspection/InspectionFilesStorage";
import { api } from "../../../services/api/ApiService";
import useErrorHandler, { ApplicationError }  from "../../../services/error-handler/ErrorHandlerService";

interface VideoLoaderProps {
    video?: Video;
    canConvert?: boolean;
    reloadFunction?: () => void;
}

export default observer(function VideoLoader(props:VideoLoaderProps) {
    const {video, canConvert, reloadFunction} = props;
    const { themeClass } = useTheme();
    const { handleErrorInSnackbar } = useErrorHandler();

    const [inspectionFilesStorage] = useState(() =>
        InspectionFilesStorageModel.create({ uploadService: { isUploadInProgress: false } }, { api })
      );

    const handleRetryConversion = useCallback(async () => {
        if (video) {
          try {
            await inspectionFilesStorage.convertVideo(
              video.id
            );
            if (reloadFunction) await reloadFunction();
          } catch (error) {
            const applicationError = error as ApplicationError;
            handleErrorInSnackbar(applicationError);
          }
        }
      }, [video, inspectionFilesStorage, handleErrorInSnackbar, reloadFunction]);

    return (
        <>
            {video?.isConverting && (
                <div className={themeClass(["video-not-available"])}>
                <LoadingSpinner spinnerOnly />
                <p className={themeClass(["message"])}>
                    {translationService.translate("damages.DamagesVideo.video-conversion-format-message")}
                </p>
                <p className={themeClass(["message"])}>
                    {translationService.translate("damages.DamagesVideo.video-conversion-wait-message")}
                </p>
                </div>
            )}
            {video?.conversionFailed && (
                <div className={themeClass(["video-failed-conversion"])}>
                    <div className="svg-warning">
                        <Svg svg={Warning} width={100} />
                    </div>
                    {canConvert && (
                    <>
                        <p className={themeClass(["message"])}>
                        {` ${translationService.translate(
                            "damages.DamagesVideo.video-conversion-failed-message"
                        )} `}
                        <span onClick={handleRetryConversion}>
                            {translationService.translate(
                            "damages.DamagesVideo.video-conversion-error-warning-link"
                            )}
                        </span>
                        </p>
                        <p className={themeClass(["message"])}>
                        {` ${translationService.translate(
                            "damages.DamagesVideo.video-conversion-error-warning-contact"
                        )} `}
                        </p>
                    </>
                    )}
                    {!canConvert && (
                    <>
                        <p className={themeClass(["message"])}>
                        {` ${translationService.translate(
                            "damages.DamagesVideo.video-conversion-failed-message"
                        )} `}
                        </p>
                        <p className={themeClass(["message"])}>
                        {` ${translationService.translate(
                            "damages.DamagesVideo.video-conversion-error-warning-for-guests"
                        )} `}
                        </p>
                    </>
                    )}
                    <p className={themeClass(["message", "margin"])}>
                        {video.conversionErrorMessage}
                    </p>
                </div>
            )}
        </>
    )
})
